module.exports = __webpack_public_path__ + "img/phone-call.8b2f97f7.svg";